import { respondToExternalCalendarEvent as _respondToExternalCalendarEvent } from '@griply/services';
import {
  CalendarEventWriteResult,
  RespondToCalendarEventInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';
import { reportUnknownCalendarEventError } from './helpers/report-unknown-calendar-event-error';

export const respondToExternalCalendarEvent = async (
  payload: RespondToCalendarEventInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _respondToExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    reportUnknownCalendarEventError(
      error,
      'external-calendars-respond-to-event',
    );
    throw error;
  }
};
